import { ReviewRow, ReviewMediaRow } from '../ReviewRow/ReviewRow'

const ReviewDisplayContentTab = ({ activeLanguage, salesTargetData }) => {
  const { displayContent, displayContentMedia, displayContentMediaOptional} = salesTargetData
  const imageUri = displayContentMedia?.imageUri || displayContentMedia?.imageUrl || '';
  const imageUriOptional = displayContentMediaOptional?.imageUri || displayContentMediaOptional?.imageUrl || '';
  const data = displayContent?.[activeLanguage] || {}
  const getAnswer = val => (val? 'Yes' : 'No')

  const renderMediaSection = (imageUri, displayContentMedia, downloadFileName, testId) => {
    if (!imageUri || imageUri === '') return null;
    
    return (
      <div className="md:w-1/2 w-full">
        <div className="review_subtitle">Media</div>
        <div className="grid grid-cols-1">
          <div className="grid_wrap">
            <a href={imageUri} download={downloadFileName} className="review_image_row grid grid-cols-2 gap-y-2 cursor-pointer" >
              <img src={imageUri} alt="Pepsi Logo" />
            </a>
            <ReviewMediaRow data-testid={testId} label="Title" value={displayContentMedia?.title} />
            <ReviewMediaRow label="Opt In" value={getAnswer(displayContentMedia?.optIn)} />
            <ReviewMediaRow label="Image Id" value={displayContentMedia?.imageId} />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div data-testid="ReviewdisplayContentForm">
      <div className="review_subtitle mtb30">Display</div>
      <div className="grid">
        <div className="grid_wrap">
          <ReviewRow data-testid="display-title-label" label="Title" value={data.title} />
          <ReviewRow data-testid="display-category-label" label="Category For Target Title" value={data?.category} />
          <ReviewRow label="Excerpt" value={data.excerpt} />
          <ReviewRow label="Terms" value={data.terms} />
        </div>
      </div>
      <div className="flex md:flex-row flex-col gap-14">

      {renderMediaSection(
        imageUri, 
        displayContentMedia, 
        "display_content_image.png", 
        "display-title-label"
      )}
      {renderMediaSection(
        imageUriOptional, 
        displayContentMediaOptional, 
        "display_content_image_optional.png", 
        "display-title-label"
      )}
      </div>
    </div >
  )
}

export default ReviewDisplayContentTab
